export default __webpack_public_path__ + "static/media/vector1.50660b65.svg";